import { IStudentRow } from 'api-paths-cas';

export const getDaysInCurrentStage = (student: IStudentRow) => {
  return student.casStatusUpdatedAt
    ? getDaysBetweenTwoDatesByTimestamp(student.casStatusUpdatedAt, new Date().getTime()).toString()
    : '';
};

export const getDaysBetweenTwoDatesByTimestamp = (to: number, from: number): number => {
  return Math.abs(Math.round((from - to) / (1000 * 60 * 60 * 24)));
};
